/**
 * NewsPanel — the full event log / industry wire.
 */

import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { PanelSection } from '@/components/game/ui';
import { useGameStore } from '@/store/gameStore';
import { formatGameDate } from '@/game/format';
import { EVENT_CATEGORY_META } from '@/game/constants';

export function NewsPanel() {
  const state = useGameStore((s) => s.state)!;

  return (
    <PanelSection title="The Wire" desc="Every headline, decision, and quarterly gut-punch in one feed.">
      <ul className="space-y-2">
        {state.news.map((n) => {
          const meta = EVENT_CATEGORY_META[n.category];
          return (
            <li
              key={n.id}
              className={cn(
                'rounded-xl border bg-card p-4',
                n.severity >= 4 && 'border-red-500/40',
                n.severity === 3 && 'border-amber-500/40',
              )}
            >
              <div className="flex flex-wrap items-center gap-2 pb-1 text-xs text-muted-foreground">
                <Badge variant="outline" className="text-[10px]">{meta?.label ?? n.category}</Badge>
                <span>{formatGameDate(n.day)}</span>
                {n.severity >= 3 && <span className={n.severity >= 4 ? 'text-red-500' : 'text-amber-500'}>severity {n.severity}/5</span>}
              </div>
              <p className="text-sm font-medium leading-snug">{n.headline}</p>
              {n.detail && <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{n.detail}</p>}
            </li>
          );
        })}
        {state.news.length === 0 && (
          <li className="rounded-xl border border-dashed p-8 text-center text-sm text-muted-foreground">
            Quiet out there. Suspiciously quiet.
          </li>
        )}
      </ul>
    </PanelSection>
  );
}
